<template>
    <div id="pro-layout">
        <div class="pro-main-container">
            <div id="pro-cmaj-form">
                <div class="pt-5 pb-5 header w-100">
                    <div class="mx-auto col-11 d-flex justify-content-between" v-if="loaded">
                        <div>
                            <h4 style="color: gray" v-if="formTitle !== null">{{ formTitle }}</h4>
                            <h1 v-if="cadhTitle !== null" class="main-title-form">{{ cadhTitle }}</h1>
                            <h1 v-else>Formulaire d'adhésion</h1>
                        </div>
                        <div class="logo ml-3">
                            <v-img height="100px" max-width="300px" position="right" contain :src="logo"></v-img>
                        </div>
                    </div>
                    <div v-else>
                        <content-placeholders class="d-flex justify-content-between">
                            <content-placeholders-heading class="place-holder-title-xs" style="width: 400px; height: 51px"/>
                            <content-placeholders-img class="place-holder-title-lg ml-3" style="width: 150px; height: 80px">
                            </content-placeholders-img>
                        </content-placeholders>
                    </div>
                </div>

                <div class="pro-main-container-bloc pt-5" v-if="loaded"
                     :style="'background-color:' + backGroundColor + '!important'">
                    <adhesion-preview class="mx-auto col-11" :config-id="cadhConfigId"></adhesion-preview>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CadhPreview",
    data() {
        return {
            logo: null,
            cadhTitle: null,
            cadhConfigId: null,
            loaded: false,
            formTitle: null,
            cadhConfigToken: null,
            backGroundColor: '#f4f5f7',
        }
    },
    methods: {
        getCadhTitle() {
            this.$http.get('campaigns/cadh/cadh-title/' + this.cadhConfigToken).then(res => {
                this.cadhTitle    = res.body.data.title
                this.logo         = res.body.data.logo
                this.cadhConfigId = res.body.data.cadhConfigId

                if(this.$route.query.style !== undefined) {
                    let testedStyles = JSON.parse(this.$route.query.style)

                    this.backGroundColor = testedStyles.background
                } else if(res.body.data.backgroundColor !== null) {
                    this.backGroundColor = res.body.data.backgroundColor
                }

                this.loaded = true
            })
        },
        getFormTitle() {
            this.$http.get('campaigns/cadh/title-enabled/' + this.cadhConfigToken).then(res => {
                let enabled = res.body.data.enabled

                if (enabled) {
                    this.formTitle = "Nom du prestataire (test)"
                }
            })
        },
    },
    created() {
        this.cadhConfigToken = this.$route.params.token

        this.getCadhTitle()
        this.getFormTitle()
    }
}
</script>